import axios from "../../axios";
import { addTourSeen } from "../../redux/slices/auth";

// Тури й підказки по кабінету (components/CabinetTour, components/Hint). Що вже показано — у базі (tourSeen),
// щоб на іншому пристрої не вилазило знову.
export const TOUR_STUDENT = "cabinet-student";
export const TOUR_TEACHER = "cabinet-teacher";
export const OPEN_TOUR_EVENT = "open-cabinet-tour";
export const FIRST_STEPS_HIDDEN = "first-steps-hidden";

// Сам тур відкривається лише новим акаунтам; старим — за кнопкою на головній
const NEW_ACCOUNT_DAYS = 30;

export const wasSeen = (user, id) => Boolean(user?.tourSeen?.includes(id));

export const isNewAccount = (user) => {
  const created = new Date(user?.createdAt);
  return !Number.isNaN(created.getTime()) && Date.now() - created.getTime() < NEW_ACCOUNT_DAYS * 24 * 3600 * 1000;
};

export const markSeen = (dispatch, id) => {
  dispatch(addTourSeen(id));
  axios.post("auth/tour-seen", { tour: id }).catch(() => {});
};

export const openCabinetTour = () => window.dispatchEvent(new Event(OPEN_TOUR_EVENT));

// Поки йде тур, підказки (Hint) мовчать
export const TOUR_STATE_EVENT = "cabinet-tour-state";
let tourOpen = false;
export const isTourOpen = () => tourOpen;
export const setTourOpen = (open) => {
  tourOpen = open;
  window.dispatchEvent(new Event(TOUR_STATE_EVENT));
};
